module.exports = __webpack_public_path__ + "img/ordem-crescente.79b8fd46.svg";